import { api } from "./api.ts";
import type { MSAAllocation } from "types/DataTypes";

export const reportsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getReportPrescriptionAllocationById: build.query<
      MSAAllocation,
      {
        id: string;
      }
    >({
      query: ({ id }) => ({
        url: `api/v1/report-prescription-allocations/${id}/`,
        method: "GET",
      }),
      providesTags: (result, error, arg) => [
        { type: "ReportPrescriptionAllocation", id: arg.id },
      ],
    }),
    patchReportPrescriptionAllocationById: build.mutation<
      MSAAllocation,
      {
        id: string;
        data: Partial<MSAAllocation>;
      }
    >({
      query: ({ id, data }) => ({
        url: `api/v1/report-prescription-allocations/${id}/`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "ReportPrescriptionAllocation", id: arg.id },
        "MSADecision",
      ],
    }),
    getReportTreatmentAllocationById: build.query<
      MSAAllocation,
      {
        id: string;
      }
    >({
      query: ({ id }) => ({
        url: `api/v1/report-treatment-allocations/${id}/`,
        method: "GET",
      }),
      providesTags: (result, error, arg) => [
        { type: "ReportTreatmentAllocation", id: arg.id },
      ],
    }),
    patchReportTreatmentAllocationById: build.mutation<
      MSAAllocation,
      {
        id: string;
        data: Partial<MSAAllocation>;
      }
    >({
      query: ({ id, data }) => ({
        url: `api/v1/report-treatment-allocations/${id}/`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "ReportTreatmentAllocation", id: arg.id },
        "MSADecision",
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  usePatchReportPrescriptionAllocationByIdMutation,
  usePatchReportTreatmentAllocationByIdMutation,
  useGetReportPrescriptionAllocationByIdQuery,
  useGetReportTreatmentAllocationByIdQuery,
} = reportsApi;
